import React from "react";
import { Link } from "react-router-dom";

const CONTACT_EMAIL = "contato@kosmosai.com.br";

export default function PoliticaDePrivacidade() {
  return (
    <div className="min-h-screen bg-[#F4F7FB]">
      <header className="sticky top-0 z-50 border-b border-[#D1DEEE] bg-white">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-6">
          <Link to="/" data-testid="privacy-home-link" aria-label="Voltar para a página inicial do TUTO">
            <img src="/logo-tuto.png" alt="TUTO by Kosmos" className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="text-sm font-medium text-[#335480] transition-colors hover:text-[#003882]"
          >
            Voltar ao início
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-12 md:py-16">
        <article className="border border-[#D1DEEE] bg-white p-6 md:p-10">
          <div className="mb-10 border-b border-[#D1DEEE] pb-8">
            <p className="mb-3 text-sm font-medium text-[#335480]">Documentos legais</p>
            <h1 className="mb-4 text-4xl font-bold text-[#001533]" style={{ fontFamily: "Cabinet Grotesk" }}>
              Política de Privacidade
            </h1>
            <p className="text-sm text-[#335480]">Vigência: 28 de agosto de 2026 · Versão 1.2</p>
          </div>

          <div className="max-w-[72ch] space-y-9 text-base leading-7 text-[#335480]">
            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">1. Escopo e responsável pelo tratamento</h2>
              <p>
                Esta Política explica como a <strong>Keep Soluções Tecnológicas Ltda.</strong>, CNPJ 08.277.372/0001-71,
                trata dados pessoais no TUTO, identificado no produto como “TUTO by KOSMOS”, em conformidade com a Lei
                Geral de Proteção de Dados Pessoais (LGPD — Lei nº 13.709/2018).
              </p>
              <p className="mt-3">
                A Keep atua como controladora dos dados necessários à relação com usuários, como cadastro, conta, cobrança,
                suporte e segurança. Para dados de clientes, partes e demais terceiros inseridos pelo escritório no workspace,
                o escritório ou profissional que decide sobre esse uso normalmente atua como controlador; o TUTO trata esses
                dados para viabilizar o serviço, conforme as instruções e permissões do workspace.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">2. Dados que tratamos</h2>
              <h3 className="mb-2 mt-4 text-base font-semibold text-[#001533]">Dados de cadastro e uso da conta</h3>
              <ul className="list-disc space-y-2 pl-6">
                <li>nome, e-mail, imagem de perfil quando informada e dados de autenticação;</li>
                <li>identificação do workspace, função de acesso, convites e configurações de notificação;</li>
                <li>registros de sessão e atividade necessários para proteger a conta e administrar o serviço.</li>
              </ul>

              <h3 className="mb-2 mt-5 text-base font-semibold text-[#001533]">Dados do workspace e do serviço</h3>
              <ul className="list-disc space-y-2 pl-6">
                <li>dados de OAB, números de processos, informações processuais, movimentações e publicações obtidas de fontes compatíveis;</li>
                <li>dados de partes e demais informações pessoais que possam constar em processos ou publicações;</li>
                <li>notas, tarefas, agenda, audiências, prazos e demais conteúdo inserido ou gerado no uso do TUTO.</li>
              </ul>

              <h3 className="mb-2 mt-5 text-base font-semibold text-[#001533]">Dados de integrações e cobrança</h3>
              <ul className="list-disc space-y-2 pl-6">
                <li>dados básicos fornecidos pelo Google para login, quando você escolhe essa forma de acesso;</li>
                <li>e-mail da conta Google, identificador do calendário e credencial de integração quando você conecta o Google Agenda;</li>
                <li>identificador do chat do Telegram quando você vincula o recebimento de alertas;</li>
                <li>identificadores de cliente, sessão e status de pagamento da Stripe. O TUTO não armazena os dados completos do seu cartão.</li>
              </ul>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">3. Para que usamos os dados</h2>
              <ul className="list-disc space-y-2 pl-6">
                <li>criar e manter contas, workspaces e permissões de acesso;</li>
                <li>prestar as funcionalidades de monitoramento, organização de processos, agenda, tarefas e alertas;</li>
                <li>sincronizar dados com fontes e integrações que você decidir conectar;</li>
                <li>processar contratação, cobrança, gestão da assinatura e prevenção a fraudes;</li>
                <li>enviar comunicações operacionais, suporte e avisos importantes sobre o serviço;</li>
                <li>manter segurança, diagnosticar falhas e aprimorar a experiência do produto;</li>
                <li>cumprir obrigações legais, regulatórias e atender solicitações válidas de autoridades.</li>
              </ul>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">4. Bases legais</h2>
              <p>Conforme o caso, o tratamento é realizado com base em:</p>
              <ul className="mt-3 list-disc space-y-2 pl-6">
                <li>execução de contrato e procedimentos relacionados à contratação do TUTO;</li>
                <li>cumprimento de obrigação legal ou regulatória;</li>
                <li>legítimo interesse para segurança, prevenção a fraude, suporte e melhoria do serviço, com avaliação de impacto quando necessária;</li>
                <li>consentimento, quando uma integração ou finalidade específica exigir essa manifestação.</li>
              </ul>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">5. Com quem compartilhamos dados</h2>
              <p>Compartilhamos dados apenas quando necessário para operar o TUTO, incluindo:</p>
              <ul className="mt-3 list-disc space-y-2 pl-6">
                <li><strong>Stripe</strong>, para checkout, assinatura e cobrança da sua assinatura do TUTO;</li>
                <li><strong>Google</strong>, para login e Google Agenda, somente quando você utilizar essas integrações;</li>
                <li><strong>Telegram</strong>, para alertas no chat que você vincular;</li>
                <li><strong>Asaas</strong>, quando você conecta sua conta para emitir cobranças. Nesse caso enviamos ao
                    Asaas o nome e o CPF/CNPJ do cliente que você indicar, além do e-mail e telefone de contato quando
                    cadastrados, e os dados da cobrança;</li>
                <li><strong>Escavador</strong>, que executa a pesquisa de jurisprudências. O termo pesquisado é enviado
                    ao provedor para obter o resultado;</li>
                <li><strong>fontes processuais compatíveis</strong>, como DataJud, DJEN e PJe, para consultas vinculadas
                    ao serviço, incluindo o gateway de integração operado pela Kosmos, do mesmo grupo econômico;</li>
                <li><strong>provedores de infraestrutura, banco de dados e e-mail transacional</strong>, contratados para
                    armazenar dados e enviar comunicações do TUTO;</li>
                <li><strong>Google Analytics e Microsoft Clarity</strong>, para medir navegação e uso do site e do produto.</li>
              </ul>
              <p className="mt-3">
                Também poderemos compartilhar dados quando isso for exigido por lei, ordem judicial ou solicitação válida
                de autoridade competente. Não vendemos dados pessoais nem os disponibilizamos para publicidade direcionada de terceiros.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">
                5.1. Dados dos clientes do seu escritório
              </h2>
              <p>
                Ao usar Clientes, Financeiro ou a cobrança pelo Asaas, você insere no TUTO dados pessoais de terceiros —
                por exemplo nome, CPF/CNPJ, e-mail e telefone dos seus clientes. Nessa hipótese, <strong>você é o
                controlador</strong> desses dados e o TUTO atua como <strong>operador</strong>, tratando-os conforme suas
                instruções e o disposto nesta Política.
              </p>
              <p className="mt-3">
                Cabe a você garantir base legal para inserir esses dados, informar seus clientes quando exigido e atender
                aos direitos que eles exercerem. Cabe ao TUTO tratar esses dados apenas para prestar o serviço, com as
                medidas técnicas descritas na seção de segurança.
              </p>
              <p className="mt-3">
                Documentos como CPF e CNPJ são armazenados de forma cifrada e ficam ocultos na interface. Cada exibição
                ou envio a terceiro — como ao emitir uma cobrança no Asaas — é registrado em trilha de auditoria com
                autor, data e motivo.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">6. Integrações opcionais</h2>
              <p>
                O Google Agenda usa o escopo necessário para criar e administrar o calendário “TUTO — Prazos e Audiências”
                criado pelo próprio aplicativo. Eventos do workspace são enviados a esse calendário para espelhamento. O TUTO
                não solicita permissão para ler ou modificar os demais calendários da conta Google.
              </p>
              <p className="mt-3">
                Na integração com o Asaas, a chave de API do seu escritório é armazenada de forma cifrada e usada apenas
                para criar e consultar cobranças a seu pedido. A conta no Asaas é sua, e a relação de pagamento se dá
                entre você e o Asaas. Você pode desconectar ou trocar a chave a qualquer momento nas Configurações.
              </p>
              <p className="mt-3">
                Você pode desvincular o Google Agenda e o Telegram nas configurações. Ao desconectar o Google Agenda, o
                vínculo e a credencial mantidos pelo TUTO são removidos e a revogação é solicitada ao Google; o calendário
                que já foi criado continua na sua conta até que você o exclua por lá.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">7. Cookies, sessões e métricas</h2>
              <p>
                Usamos um cookie essencial de sessão para manter a autenticação e proteger o acesso à conta. Sem ele,
                funcionalidades autenticadas não operam adequadamente. Utilizamos também o Google Analytics para medir
                páginas visitadas e interações no site e no produto. As configurações do navegador permitem gerenciar ou
                bloquear cookies; o bloqueio de cookies essenciais pode impedir o login.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">8. Retenção e exclusão</h2>
              <p>
                Mantemos os dados enquanto forem necessários para prestar o serviço, cumprir obrigações legais, resolver
                disputas ou exercer direitos. Registros de sessão expiram em até 7 dias, salvo renovação por novo acesso.
              </p>
              <p className="mt-3">
                Para workspaces FREE inativos, o TUTO pode enviar um aviso após 30 dias sem atividade. Se não houver retorno
                em 15 dias após o aviso, os dados operacionais do workspace — incluindo usuários, processos, publicações,
                agenda e transações registradas no TUTO — são removidos. Poderemos reter dados mínimos de identificação e
                contato quando isso for necessário para obrigações legais, segurança, comprovação de operações ou comunicações
                relacionadas ao serviço. Para solicitar exclusão antes desse ciclo, use o canal de privacidade abaixo.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">9. Segurança</h2>
              <p>
                Adotamos medidas técnicas e administrativas razoáveis para proteger os dados, como controle de acesso,
                sessões com proteção de navegador, separação de dados por workspace e monitoramento operacional. Nenhum
                ambiente conectado à internet é absolutamente imune a riscos. Se identificarmos um incidente que possa gerar
                risco ou dano relevante aos titulares, adotaremos as medidas de resposta e comunicação previstas na LGPD.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">10. Transferências internacionais</h2>
              <p>
                Alguns fornecedores utilizados pelo TUTO, como Stripe, Google, Telegram e Google Analytics, podem tratar dados
                fora do Brasil. Quando isso ocorrer, buscamos utilizar mecanismos e salvaguardas compatíveis com a LGPD e com
                as regras aplicáveis à transferência internacional de dados.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">11. Seus direitos</h2>
              <p>Você pode solicitar, nos limites da LGPD:</p>
              <ul className="mt-3 list-disc space-y-2 pl-6">
                <li>confirmação da existência de tratamento e acesso aos seus dados;</li>
                <li>correção de dados incompletos, inexatos ou desatualizados;</li>
                <li>anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade;</li>
                <li>portabilidade, quando aplicável;</li>
                <li>informação sobre compartilhamentos e sobre as consequências de não fornecer consentimento;</li>
                <li>revogação do consentimento e revisão de decisões automatizadas, quando aplicável.</li>
              </ul>
              <p className="mt-3">
                Para proteger sua conta, poderemos pedir informações adicionais para confirmar sua identidade antes de atender
                uma solicitação. Se o pedido envolver dados inseridos por um escritório, poderemos orientá-lo a contatar o
                controlador responsável por aquele workspace.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">12. Alterações nesta Política e contato</h2>
              <p>
                Podemos atualizar esta Política para refletir mudanças no TUTO ou na legislação. A versão vigente sempre estará
                nesta página, com a data de vigência. Alterações relevantes serão comunicadas por meio apropriado.
              </p>
              <div className="mt-4 border border-[#D1DEEE] bg-[#F4F7FB] p-5 text-sm leading-6">
                <p className="font-semibold text-[#001533]">Canal de privacidade — Keep Soluções Tecnológicas Ltda.</p>
                <p>CNPJ 08.277.372/0001-71</p>
                <p>
                  E-mail: <a href={`mailto:${CONTACT_EMAIL}`} className="font-medium text-[#003882] hover:text-[#00285e]">{CONTACT_EMAIL}</a>
                </p>
              </div>
            </section>
          </div>
        </article>
      </main>

      <footer className="mt-8 bg-[#001533] px-6 py-8 text-white">
        <div className="mx-auto flex max-w-4xl flex-col items-center justify-between gap-3 text-center text-sm md:flex-row md:text-left">
          <p className="text-[#D1DEEE]">© 2026 TUTO — Powered by Kosmos</p>
          <Link to="/termos-de-uso" data-testid="privacy-footer-terms-link" className="font-medium text-white hover:text-[#D1DEEE]">
            Termos de Uso
          </Link>
        </div>
      </footer>
    </div>
  );
}